import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";

export interface DisqualifyLead extends GtagEvent {
    currency:ISO_4217;
    value: number;
    disqualified_lead_reason?:string;
}
export const disqualify_lead = ($_:DisqualifyLead) => event('disqualify_lead',$_);